import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import * as color from "./../../../assets/styles/colors/partner-colors.json";
import { Title } from "@angular/platform-browser";
declare var $: any;

@Injectable({
	providedIn: "root"
})
export class PartnerService {
	colorObject = (color as any).default;

	partnerList: IPartnerServiceList[] = [
		{
			code: "carsome",
			title: "Carsome | Car Insurance",
			showWhatsapp: true
		},
		{
			code: "carsome",
			title: "Carsome | Car Insurance",
			showWhatsapp: true
		},
		{
			code: "mg",
			title: "MG | Car Insurance",
			showWhatsapp: false
		},
		{
			code: "fundingsocieties",
			title: "Funding Societies | Car Insurance",
			showWhatsapp: false
		},
		{
			code: "imotorbike",
			title: "iMotorbike | Car Insurance",
			showWhatsapp: false
		}
	];

	constructor(private router: Router, public titleService: Title) {}

	getPartnerCode() {
		// let urlParams = new URLSearchParams(window.location.search);
		// let partnerCode = urlParams.get("partnerCode");

		// // set PartnerCode on query params
		// if (partnerCode) {
		// let partner = this.partnerList.find((x) => x.code == partnerCode);
		// if (!partner) {
		// 		partnerCode = partner?.code;
		// 	}

		// }

		let partnerCode: string = "";
		const matchedPartner: IPartnerServiceList = this.partnerList.find(
			(partner) => this.router.url.includes(partner.code)
		);

		if (matchedPartner) partnerCode = matchedPartner.code;

		// Change favicon
		if (partnerCode) {
			this.titleService.setTitle(
				this.partnerList.find((x) => x.code == partnerCode)?.title
			);
			$("link[rel*='icon']").attr(
				"href",
				`assets/icons/affiliate/${partnerCode}.ico`
			);
		}
		// Switch the styles on partnerCode
		let colorPartnerCode = "default";
		if (partnerCode) {
			colorPartnerCode = partnerCode;
		}
		let colorList = this.colorObject[colorPartnerCode];
		colorList.forEach((x: { root: string; value: string }) => {
			document.documentElement.style.setProperty(x.root, x.value);
		});
		return partnerCode;
	}

	getPartnerAttribute(partnerCode: string, type: string) {
		let partner = this.partnerList.find((x) => x[type] == true);
		if (partner.code == partnerCode) return true;
		else return false;
	}

	setPartnerAttribute(
		partnerCode: string,
		type: string,
		value: boolean | string
	) {
		let partner = this.partnerList.find((x) => x[partnerCode] === x.code);
		if (partner) {
			partner[type] = value;
		}
	}
}

export interface IPartnerServiceList {
	code: string;
	title: string;
	showWhatsapp: boolean;
}
